import { render, staticRenderFns } from "./UserInfoBase.vue?vue&type=template&id=0cf6ea10&scoped=true&"
import script from "./UserInfoBase.vue?vue&type=script&lang=js&"
export * from "./UserInfoBase.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoBase.vue?vue&type=style&index=0&id=0cf6ea10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf6ea10",
  null
  
)

export default component.exports